import { render, staticRenderFns } from "./braceletLocation.vue?vue&type=template&id=3d116976&scoped=true&"
import script from "./braceletLocation.vue?vue&type=script&lang=js&"
export * from "./braceletLocation.vue?vue&type=script&lang=js&"
import style0 from "./braceletLocation.vue?vue&type=style&index=0&id=3d116976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d116976",
  null
  
)

export default component.exports